import { render, staticRenderFns } from "./maxBox.vue?vue&type=template&id=670ca674&"
import script from "./maxBox.vue?vue&type=script&lang=js&"
export * from "./maxBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports